import GhostContentAPI from '@tryghost/content-api';

const ghostUrl = (import.meta.env.GHOST_URL || '').replace(/\/+$/, '');
const ghostKey = import.meta.env.GHOST_API_TOKEN || '';
const configured = Boolean(ghostUrl && ghostKey);

if (!configured) {
  console.error('Ghost CMS configuration missing: GHOST_URL and GHOST_API_TOKEN are required.');
}

const api = configured
  ? new GhostContentAPI({ url: ghostUrl, key: ghostKey, version: 'v5.0' })
  : null;

export async function getPosts() {
  if (!api) throw new Error('Ghost CMS is not configured');
  return api.posts.browse({
    include: 'tags,authors',
    fields: 'id,title,slug,feature_image,published_at,custom_excerpt,excerpt',
  });
}

export async function getPostBySlug(slug) {
  if (!api) throw new Error('Ghost CMS is not configured');
  return api.posts.read(
    { slug },
    { include: 'tags,authors', formats: 'html' },
  );
}
